import React from 'react'
import { ITag } from '../../../../core/api/dto/TagsDto'
import { AppMultiDropdownWithPagination } from '../../../../components/AppDropdown/AppMultiDropdownWithPagination'
import { useGetTagsListQuery } from '../../../../core/api/TagsApi'
import { useTranslation } from 'react-i18next'

interface IPlanMenuCloseTagsBlock {
  tags: ITag[]
  setTags: (value: ((prevState: ITag[]) => ITag[]) | ITag[]) => void
  disabled?: boolean
  editMode?: boolean
}

export const PlanMenuCloseTagsBlock = ({
  tags,
  setTags,
  disabled,
  editMode,
}: IPlanMenuCloseTagsBlock) => {
  const { t } = useTranslation()
  const onRemoveTagItem = (id: number) => {
    const newTags = tags.filter((tag) => tag.id !== id)
    setTags(newTags)
  }

  return (
    <div>
      {!!tags.length ? (
        <React.Fragment>
          <label>{t('Выбранные тэги')}</label>
          <div className="choose-items-block full-width">
            {tags.map((item) => (
              <div className="choose-item" key={item.id}>
                {item.name}
                {!!editMode && (
                  <i
                    className="an-ico an-ico-close"
                    onClick={
                      disabled ? undefined : () => onRemoveTagItem(item.id)
                    }
                  />
                )}
              </div>
            ))}
          </div>
        </React.Fragment>
      ) : (
        <div className="comment-block">
          <div className="title-block">
            <span>
              <b>{t('Тэги')}</b>
            </span>
          </div>
          <div className="content">
            <div className="text">
              <span>{t('Тэги не выбраны')}</span>
            </div>
          </div>
        </div>
      )}
      <div className={'mt-10'}>
        {!!editMode && (
          <AppMultiDropdownWithPagination<ITag, keyof ITag>
            label={'Тэги'}
            value={tags}
            tag={true}
            getterData={useGetTagsListQuery}
            propToShowInInput={'name'}
            propToShowInList={'name'}
            border
            fullWidth
            placeholder="Выбрать"
            onChange={setTags}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  )
}
